import React, { Component, useState, useEffect } from 'react';
import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import { Trans, withTranslation, useTranslation } from 'react-i18next';

const DontAskAgainDialog = (props) => {

  const storageKey = `ly_not_ask_again_${props.context}`;

  const [isOpen, setIsOpen] = useState(false);
  const [notAskAgain, setAskAgain] = useState(localStorage.getItem(storageKey));

  const t = props.t;

  useEffect(() => {
    if(props.open === true) {
      if(localStorage.getItem(storageKey)) {
        if(props.onSubmit) {
          handleSubmit();
        }
      } else {
        setIsOpen(true);
      }
      if(props.initialChecked) {
        handleAskAgain({target: {checked: true}});
      }
    }
  }, [props.open]);

  const closeDialog = (e) => {
    setAskAgain(false);
    setIsOpen(false);
    setAskAgain(false);
    if(props.onClose) {
      props.onClose();
    }
  }

  const handleAskAgain = event => {
    if(!event.target.checked) {
      localStorage.removeItem(storageKey);
    } else {
      localStorage.setItem(storageKey, event.target.checked);
    }
    setAskAgain(event.target.checked);
  };

  const handleSubmit = (e) => {
    if(props.onSubmit) {
      props.onSubmit();
    }
    closeDialog();
  }

  const handleCancel = () => {
    localStorage.removeItem(storageKey);
    if(props.onCancel) {
      props.onCancel();
    }
    closeDialog();
  }

  return (
    <Dialog
      onClose={!props.suppressBackdropClick ? closeDialog : null}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
    >
      <DialogTitle id="customized-dialog-title" onClose={() => setIsOpen(false)}>
        <Typography variant="h5" component="span">
          {props.icon && <Box component="span" sx={{ mr: '5px', mt: '-5px', '& svg': { mt: '-5px' } }}>{props.icon}</Box>}
          {props.title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        {props.content}
      </DialogContent>
      <DialogActions>
        <FormControlLabel
          control={
            <Checkbox
              style={{paddingRight: 6}}
              checked={notAskAgain || false}
              onChange={handleAskAgain}
              value="notAskAgain"
            />
          }
          style={{
            marginRight: 16, 
            opacity: props.visuallyHideCheckbox ? 0 : 1,
            cursor: props.visuallyHideCheckbox ? 'default' : 'pointer',
          }}
          label={t('system.notAskAgain')}
        />
        <Button variant="outlined" onClick={handleCancel} size="medium">
          {t('system.cancel')}
        </Button>
        <Button variant="contained" onClick={handleSubmit} color="primary" size="medium">
          {t('system.continue')}
        </Button>
      </DialogActions>
    </Dialog>
  );
} 

export default withTranslation()(DontAskAgainDialog);